module.exports = __webpack_public_path__ + "static/img/20010 (3).c134b34.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (3).webp
// module id = NDN8
// module chunks = 14